import { Toaster as SonnerToaster, type ToasterProps } from 'sonner';

/**
 * Sonner Toaster — single global mount in src/App.tsx.
 *
 * Use `toast()` from 'sonner' anywhere in the modern stack to fire toasts.
 * Coexists with the legacy react-toastify <ToastContainer> until Bootstrap is
 * decommissioned in Phase 9.
 */
export function Toaster(props: ToasterProps) {
  return (
    <SonnerToaster
      position="top-right"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast:
            'tw-rounded-lg tw-border tw-bg-card tw-text-card-foreground tw-shadow-lg',
        },
      }}
      {...props}
    />
  );
}

export { toast } from 'sonner';
